import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';

import { capitalizeFirstLetter } from '@freelancerepublik/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserNotifications',
  props: {
    notifications: null
  },
  setup(__props: any) {

const $store = getCurrentInstance()?.proxy?.$store;



function hideNotification(id) {
  $store.dispatch('messages/popFlashMessage', id);
}

return { __sfc: true,$store, hideNotification, capitalizeFirstLetter }
}

})